/* Bandeau cookies de Shopify — croix de fermeture (16/09/2026).
   Le bandeau ne propose que « Accepter » et « Refuser », et il recouvre le bas de l'écran.
   La croix vaut refus des cookies non essentiels : on l'enregistre par l'API de
   confidentialité quand elle est disponible, puis on masque le bandeau pour la visite. */
(function () {
  var KEY = 'hg_cookies_fermees';
  var SELECTEUR = '#shopify-pc__banner';

  function fermer(banner) {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && p.setTrackingConsent) {
        p.setTrackingConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false }, function () {});
      }
    } catch (e) {}
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    banner.style.display = 'none';
  }

  function ajouterCroix() {
    var banner = document.querySelector(SELECTEUR);
    if (!banner) return false;
    var dejaFerme = false;
    try { dejaFerme = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dejaFerme) { banner.style.display = 'none'; return true; }
    if (banner.querySelector('.hg-cookie-close')) return true;
    if (window.getComputedStyle(banner).position === 'static') banner.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hg-cookie-close';
    btn.setAttribute('aria-label', 'Fermer et refuser les cookies non essentiels');
    btn.title = 'Fermer (refuser les cookies non essentiels)';
    btn.textContent = '✕';
    btn.style.cssText = 'position:absolute;top:8px;right:10px;width:34px;height:34px;padding:0;border:0;' +
      'border-radius:50%;background:rgba(3,27,52,.08);color:#031b34;font-size:16px;font-weight:700;' +
      'line-height:1;cursor:pointer;z-index:5';
    btn.addEventListener('click', function (e) { e.preventDefault(); fermer(banner); });
    banner.appendChild(btn);
    return true;
  }

  function init() {
    ajouterCroix();
    if (window.MutationObserver) {
      new MutationObserver(function () { ajouterCroix(); }).observe(document.body, { childList: true });
    }
    var essais = 0;
    var timer = setInterval(function () {
      if (ajouterCroix() || ++essais > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 07/10/2026 - Suite du meme sujet. Le bandeau est en position fixe en bas d'ecran,
   avec un z-index de 2 000 000 : il recouvrait « Voir le panier » et « Passer commande »
   dans le tiroir de panier. Mesure du 07/10 : sur 1440x900, 1280x720, 375x812 et
   390x844, les deux boutons etaient hors d'atteinte du clic tant que le visiteur
   n'avait pas repondu au bandeau.
   On reserve donc, en bas du tiroir, une hauteur egale a celle du bandeau.
   Le bandeau lui-meme n'est pas touche : « Accepter », « Refuser » et la croix du
   16/09 gardent exactement leur taille, leur couleur et leur place. */
(function () {
  var REGLE = '#hg-cart-drawer .hg-cart-drawer__footer{padding-bottom:calc(16px + var(--hg-bandeau-cookies, 0px))}';

  function poserRegle() {
    if (document.getElementById('hg-style-bandeau-tiroir')) return;
    var s = document.createElement('style');
    s.id = 'hg-style-bandeau-tiroir';
    s.textContent = REGLE;
    (document.head || document.documentElement).appendChild(s);
  }

  function hauteurBandeau() {
    var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (!b) return 0;
    var st = window.getComputedStyle(b);
    if (st.display === 'none' || st.visibility === 'hidden') return 0;
    var r = b.getBoundingClientRect();
    if (r.height <= 0) return 0;
    if (r.bottom < window.innerHeight - 8) return 0;
    return Math.ceil(r.height);
  }

  function majuster() {
    var tiroir = document.getElementById('hg-cart-drawer');
    if (!tiroir) return;
    tiroir.style.setProperty('--hg-bandeau-cookies', hauteurBandeau() + 'px');
  }

  function init() {
    poserRegle();
    majuster();
    window.addEventListener('resize', majuster);
    document.addEventListener('click', function () { setTimeout(majuster, 350); }, true);
    if (window.MutationObserver) {
      new MutationObserver(majuster).observe(document.body, { childList: true });
    }
    var n = 0;
    var t = setInterval(function () { majuster(); if (++n > 24) clearInterval(t); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
